import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { getCommentBoxId } from '../../../CommentThread/helpers';
import { focusEditor } from '../../../CommentBox/actionCreators';
/** Returns a dispatched action that will focus on the comment box with the given ids */
export default function useFocusOnCommentBox(commentableTypeId, commentableItemId, position) {
    var dispatch = useDispatch();
    var commentBoxId = getCommentBoxId(commentableTypeId, commentableItemId, position);
    return useCallback(function () {
        dispatch(focusEditor(commentBoxId));
    }, [dispatch, commentBoxId]);
}
//# sourceMappingURL=useFocusOnCommentBox.js.map